import type { OperationalStatus, Severity } from '@/types';

export function statusColor(status: OperationalStatus): string {
  switch (status) {
    case 'operational':
      return 'var(--status-operational)';
    case 'degraded':
      return 'var(--status-degraded)';
    case 'offline':
      return 'var(--status-critical)';
    case 'decommissioned':
      return 'var(--status-decommissioned)';
    case 'under_construction':
      return 'var(--status-info)';
    case 'planned':
      return 'var(--text-tertiary)';
  }
}

export function severityColor(s: Severity): string {
  switch (s) {
    case 5:
      return 'var(--sev-5)';
    case 4:
      return 'var(--sev-4)';
    case 3:
      return 'var(--sev-3)';
    case 2:
      return 'var(--sev-2)';
    case 1:
      return 'var(--sev-1)';
  }
}

export function severityLabel(s: Severity): string {
  return ['INFO', 'LOW', 'MEDIUM', 'HIGH', 'CRITICAL'][s - 1] ?? 'INFO';
}

export function criticalityRadius(rating: number): number {
  if (rating <= 2) return 6;
  if (rating === 3) return 8;
  if (rating === 4) return 10;
  return 12;
}
